import React from 'react'
import { FastField, FieldArray, useFormikContext } from 'formik'
import { Box, Button, FormHelperText, Grid, Typography } from '@mui/material'
import { CustomTextField } from 'src/form'
import { IntakeNoteComprehensiveFormType } from './IntakeNoteComprehensiveFormSchema'

export function MedicationForm() {
  const { values, status, errors } = useFormikContext<IntakeNoteComprehensiveFormType>()
  const medicationDetails = values.BIOPYCHOSOCIAL_EVALUATION?.MEDICATIONS_DETAILS || []
  const rowCount = Math.max(medicationDetails.length, 1)

  const { viewOnly } = status ?? {}
  const isViewOnly = Boolean(viewOnly)

  return (
    <>
      <Box mt={2}>
        <Typography variant="h6" color="textSecondary">
          Medication
        </Typography>
        <FieldArray name="BIOPYCHOSOCIAL_EVALUATION.MEDICATIONS_DETAILS">
          {({ push, remove }) => (
            <>
              {Array.from({ length: rowCount }).map((_, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <Grid container columnSpacing={2.5} rowSpacing={0} key={`medication-${i}`}>
                  <Grid item xs={12} md={4}>
                    <FastField
                      component={CustomTextField}
                      name={`BIOPYCHOSOCIAL_EVALUATION.MEDICATIONS_DETAILS.${i}.NAME`}
                      label="Name"
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <FastField
                      component={CustomTextField}
                      name={`BIOPYCHOSOCIAL_EVALUATION.MEDICATIONS_DETAILS.${i}.DOSAGE`}
                      label="Dosage"
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <FastField
                      component={CustomTextField}
                      name={`BIOPYCHOSOCIAL_EVALUATION.MEDICATIONS_DETAILS.${i}.FREQUENCY`}
                      label="Frequency"
                      fullWidth
                    />
                  </Grid>

                  {i > 0 && !isViewOnly && (
                    <Grid item xs={12} mt={1}>
                      <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        onClick={() => {
                          remove(i)
                        }}
                      >
                        Remove
                      </Button>
                    </Grid>
                  )}
                </Grid>
              ))}
              {!isViewOnly && (
                <Box mt={2}>
                  <Button
                    variant="outlined"
                    size="medium"
                    onClick={() => {
                      push({ NAME: '', DOSAGE: '', FREQUENCY: '' })
                    }}
                  >
                    Add medication
                  </Button>
                </Box>
              )}
            </>
          )}
        </FieldArray>

        {errors.BIOPYCHOSOCIAL_EVALUATION?.MEDICATIONS_DETAILS &&
          typeof errors.BIOPYCHOSOCIAL_EVALUATION?.MEDICATIONS_DETAILS === 'string' && (
            <FormHelperText error>{errors.BIOPYCHOSOCIAL_EVALUATION?.MEDICATIONS_DETAILS}</FormHelperText>
          )}
      </Box>
      <Box mt={2}>
        <Typography variant="h6" color="textSecondary">
          Primary Care Doctor
        </Typography>
        <Grid container columnSpacing={2.5} rowSpacing={0}>
          <Grid item xs={12} md={4}>
            <FastField
              component={CustomTextField}
              name="BIOPYCHOSOCIAL_EVALUATION.PRIMARY_CARE_DOCTOR.NAME"
              label="Name"
              fullWidth
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <FastField
              component={CustomTextField}
              name="BIOPYCHOSOCIAL_EVALUATION.PRIMARY_CARE_DOCTOR.PHONE"
              label="Phone"
              fullWidth
            />
          </Grid>
        </Grid>
      </Box>
    </>
  )
}
